import AboutTitle from "./AboutTitle";
import AboutText from "./AboutText";
import { Box } from "@mui/material";

//This component is responsible for displaying the about title and text for a resolution event 
//in a collapsed or expanded state. It is makeup of the AboutTitle and the AboutText components.
export default function About() {
    return (
        <Box>
            <AboutTitle />
            <AboutText />
        </Box>
    );
}